export default __webpack_public_path__ + "static/media/MoodImagine.ee2579be.png";